import styled from '@emotion/styled/macro';
import { H2 } from '../../../common/Headings/Headings.styles';
import Button from '../../../components/Button/Button';
import rem from '../../../utils/rem/rem';
import { HorizontalLine } from '../../StoreControl/StoreRecord.styles';

export const MenuForm = styled.div`
  margin: 0 32px;
  position: relative;
`;

export const H2WithMargin = styled(H2)`
  margin-bottom: ${rem(16)};
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${rem(16)} 24px;
  margin-bottom: ${rem(16)};
`;

export const SelectionRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  :nth-of-type(2) {
    margin-left: 11.5rem;
  }
`;

export const HR = styled(HorizontalLine)`
  margin-top: ${rem(40)};
  padding-bottom: ${rem(36)};
`;

export const SectionLabel = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(12)};
  text-transform: uppercase;
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.gray600};
  padding-bottom: ${rem(10)};
`;

export const RadioWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  gap: ${rem(16)};
  padding: 0;
  margin: 0;
  margin-bottom: ${rem(8)};
`;

export const SaveButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.blue };
  cursor: 'pointer';
  padding-left: 8px;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: ${rem(14)};
`;

export const ClearContainer = styled.div`
  cursor: 'pointer';
  display: flex;
  align-items: center;
  position: relative;
`;
